export enum CMS_PAGE_ID {
    pageLanding = 'pagina-landing',
    pageStart = 'onboarding-start',
    pageError = 'pagina-error-link',
    pageIdentification = 'pagina-indentification',
    pageConfirmation = 'pagina-confirmation',
    pageIdentityRecovery = 'pagina-identity-recovery',
    pageIdentityFixEmail = 'pagina-identity-fix-email',
    pageClientNameView = 'pagina-client-name-view',
    pageClientNameEdit = 'pagina-client-name-edit',
    pageClientData = 'pagina-client-data-fopa',
    pageClientDataLink = 'pagina-client-data-link',
    pageClientAddress = 'pagina-client-address',
    pageToken = 'pagina-token',
    pageFraudeFaceBiometry = 'pagina-fraud-face-biometry',
    pageFraudeFaceBiometryCapture = 'pagina-fraud-face-biometry-capture',
    pageFraudeFaceSelfie = 'pagina-fraud-face-selfie',
    pageFraudeFaceSelfieCapture = 'pagina-fraud-face-selfie-capture',
    pageFraudeFaceSelfieViewer = 'pagina-fraud-face-selfie-viewer',
    pageDocument = 'pagina-document',
    pageDocumentCapture = 'pagina-document-capture',
    pageDocumentViewer = 'pagina-document-viewers',
    pageOfferPackage = 'pagina-offer-package-fopa',
    pageOfferPackageLink = 'pagina-offer-package-link',
    pageOfferCard = 'pagina-offer-card-fopa',
    pageOfferCardLink = 'pagina-offer-card-link',
    pageOfferExpressCard = 'pagina-offer-express-card',
    pageOfferCardFlow = 'pagina-offer-card-flow',
    pageOfferSCP = 'pagina-offer-scp',
    pageOfferOverdraft = 'pagina-offer-overdraft',
    pageSecretAcces = 'pagina-secret-access',
    pageFinish = 'pagina-finish-link',
    pageSettings = 'pagina-settings-link',
    pageRecap='pagina-recap',
    paginaAccountHolder = 'pagina-account-holder',
    pageOfferSalaryAccount = "pagina-offer-salary-account"
}
